pnx-widget-player {
	pointer-events: none;
}

pnx-widget-player > pnx-button-group {
	pointer-events: auto;
}
